<template>
  <div
    v-if="hints.length > 0"
    class="tw-rounded-md tw-p-4 tw-mb-4 tw-bg-yellow-100"
  >
    <div class="tw-flex">
      <div class="tw-flex-shrink-0">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="tw-w-4 tw-h-4  tw-text-yellow-800 tw-mt-1">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 18v-5.25m0 0a6.01 6.01 0 001.5-.189m-1.5.189a6.01 6.01 0 01-1.5-.189m3.75 7.478a12.06 12.06 0 01-4.5 0m3.75 2.383a14.406 14.406 0 01-3 0M14.25 18v-.192c0-.983.658-1.823 1.508-2.316a7.5 7.5 0 10-7.517 0c.85.493 1.509 1.333 1.509 2.316V18" />
        </svg>
      </div>
      <div class="tw-ml-3 tw-flex tw-items-center tw-justify-between tw-w-full">
        <div class="tw-flex-1 md:tw-flex md:tw-justify-between tw-flex-col tw-text-yellow-800">
          <div :key="selectedHint" class="tw-text-sm tw-text-yellow-800" v-html="visibleHint.text"></div>
          <div class="tw-flex tw-items-center tw-space-x-2 tw-mt-2">
            <button v-if="hints.length > 1" @click="previousHint" title="Dica anterior">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="tw-w-4 tw-h-4">
                <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 9l-3 3m0 0l3 3m-3-3h7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </button>
            <p >{{selectedHint + 1}}/{{hints.length}}</p>
            <button v-if="hints.length > 1" @click="nextHint" title="Próxima dica">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="tw-w-4 tw-h-4">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12.75 15l3-3m0 0l-3-3m3 3h-7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["hints"],
  data() {
    return {
      selectedHint: 0,
    };
  },
  methods: {
    nextHint() {
      this.selectedHint =
        this.selectedHint == this.hints.length - 1 ? 0 : this.selectedHint + 1;
    },
    previousHint() {
      this.selectedHint =
        this.selectedHint == 0 ? this.hints.length - 1 : this.selectedHint - 1;
    },
  },
  computed: {
    visibleHint() {
      return this.hints[this.selectedHint];
    },
  },
};
</script>
